/* ============================================================================
   TurnOrder — MODUL CAMPANII & LEGACY (Faza 2: engine + legare sesiune↔campanie)
   ----------------------------------------------------------------------------
   Script CLASIC (fără import/export), IIFE, scope global partajat.
   Se încarcă DUPĂ tournaments.js, ÎNAINTE de feedback.js (§4.A). Umbrește prin
   Override Map (§5) funcțiile vechi de campanii din app-modules-3.js cu ACELEAȘI
   nume (last-wins), ca handlerele inline din HTML să funcționeze neschimbat.

   Faza 2 livrează: listă/creare/editare/ștergere campanii pe DB (prin RPC-urile
   SECURITY DEFINER din Faza 1), legarea unei sesiuni la o campanie prin
   meta.campaignId, butonul „+ Sesiune de campanie" și selectorul discret
   „Atașează la campanie" din foaia de sesiune. UI-ul bogat (World State, fișe de
   personaj, cronologie rich, Realtime) = Faza 3+.

   Dependențe runtime (NU redefinite): sb, state, currentClubId, can,
   requireFeature/planAllows/featureLockNote, displayNameById, memberById,
   state.membersById, openPublicProfileById, switchTab, confirmModal, promptModal,
   showNotification, getScoringTemplates, renderSessionScoreMode,
   renderSessionPlayers/renderSelectedSessionPlayers, setSessionType, avatarHtml,
   escHtml/clubEsc/attrJs, t, isDemoMode, updateTabBadges.
   ============================================================================ */
(function () {
    'use strict';

    var TC = {};
    /* Caches (fetch/paint separate — anti-flash, §11/§27.4) */
    var _campCache = [];            // [{id,name,game_id,game_title,status,world_state,...}]
    var _charByCamp = {};           // { campaignId: [profileId,...] }  (personaje ACTIVE)
    var _matchByCamp = {};          // { campaignId: [{id,game_title,date,players,winners}] }
    var _campClubId = null;         // clubul căruia îi aparțin cache-urile (anti-scurgere cross-club)
    var _campUserId = null;         // userul căruia îi aparțin cache-urile (reset la re-login)
    var _campLazyBusy = false;    var _campChannel = null;        // Faza 3c: canal Realtime dedicat (campaigns + campaign_characters)
    var _campChannelUser = null;    // userul pt. care e abonat canalul (re-abonare la re-login)
    var _campSearchQuery = '';      // Faza 5d: căutare în lista de campanii
    var _campSearchOpen = false;    // panoul de căutare deschis?
    var _rtTimer = null;            // debounce refresh Realtime
    var _openCampId = null;         // Faza 3a: campania deschisă (pagina de detaliu) sau null (listă)
    var _charsFull = {};            // { campaignId: [fișă completă,...] } (active + retrase)
    var _progByMatch = {};          // Faza 4b: { matchId: { charId: {xp,gold,level} } }
    var _journalOpen = false;       // Faza 3b: jurnalul (sesiuni legate) expandat?
    function _freshForClub() { return _campClubId === currentClubId; }
    function _curUid() { return (state.currentUser && state.currentUser.id) || null; }

    /* Flag global consumat de saveSession (supabase-integration.js): dacă e setat,
       meciul salvat primește meta.campaignId. Curățat de clearSessionForm (wrap). */
    window._sessCampaignId = window._sessCampaignId || null;

    /* ---------------------------------------------------------------- helpers */
    function _esc(x) { return (window.escHtml ? window.escHtml(x) : String(x == null ? '' : x)); }
    function _cesc(x) { return (window.clubEsc ? window.clubEsc(x) : _esc(x)); }
    function _ajs(x) { return (window.attrJs ? window.attrJs(x) : String(x == null ? '' : x)); }
    function _tt(k, fb) { try { var s = window.t ? window.t(k) : k; return (s && s !== k) ? s : (fb != null ? fb : k); } catch (e) { return fb != null ? fb : k; } }
    function _demo() { return (typeof isDemoMode === 'function') && isDemoMode(); }
    function _canManage() { return (typeof can === 'function') && can('campaign.manage'); }
    function _isAdmin() { return (typeof can === 'function') && can('member.manage'); } /* rang>=3 */
    function _canAward(c) { return _isAdmin() || !!(c && c.created_by && String(c.created_by) === String(_curUid())); } /* admin SAU creatorul campaniei (excepție pt. moderatori) */

    /* ============================================================
       NOTIFICĂRI DE CAMPANIE — folosesc pushNotification (circuitul app + push),
       exact ca la turnee (§27). Client-side, DOAR după acțiuni reușite; scriu în
       tabela `notifications` (merge cross-device). Actorul e exclus din destinatari.
       ============================================================ */
    function _campActorId() {
        return (typeof state !== 'undefined' && state.currentUser) ? state.currentUser.id : null;
    }
    /* id-urile membrilor activi ai clubului (fără actor). */
    function _campMemberIds() {
        try { if (typeof clubMemberIds === 'function') return clubMemberIds(_campActorId()); }
        catch (e) { logError('camp.memberIds', e); }
        return [];
    }
    /* trimite o notificare de campanie (dacă pushNotification e disponibil). */
    function _campNotify(ids, campId, text, icon) {
        try {
            if (!ids || !ids.length || typeof pushNotification !== 'function') return;
            pushNotification(ids, {
                clubId: currentClubId,
                type: 'campaign',
                icon: icon || 'fa-dragon',
                tab: 'campaigns',
                text: text,
                data: { route: 'campaigns', campaignId: campId }
            });
        } catch (e) { logError('camp.notify', e); }
    }
    /* text i18n cu numele campaniei interpolat pe {name}. */
    function _campNotifText(key, fallback, name) {
        return _tt(key, fallback).replace('{name}', name || '');
    }

    /* Mapează mesajul de eroare al RPC-ului (errcode/text) la o cheie i18n. PUR. */
    function _errKey(msg) {
        var m = String(msg || '');
        if (/FINAL_POINTS_NEEDS_ADMIN/.test(m)) return 'camp.err.finalNeedsAdmin';
        if (/AWARD_BAD_TARGET/.test(m)) return 'camp.err.awardTarget';
        if (/BAD_STATUS_TRANSITION/.test(m)) return 'camp.err.badTransition';
        if (/FORBIDDEN/.test(m)) return 'camp.err.forbidden';
        if (/PLAN_REQUIRED/.test(m)) return 'camp.err.plan';
        if (/NAME_REQUIRED/.test(m)) return 'camp.err.name';
        if (/BAD_GAME/.test(m)) return 'camp.err.badGame';
        if (/BAD_STATUS/.test(m)) return 'camp.err.badStatus';
        if (/BAD_PATCH/.test(m)) return 'camp.err.badPatch';
        if (/TARGET_NOT_MEMBER/.test(m)) return 'camp.err.notMember';
        if (/CHAR_NOT_FOUND/.test(m)) return 'camp.err.charNotFound';
        if (/CHAR_NOT_IN_CAMPAIGN/.test(m)) return 'camp.err.charNotInCamp';
        if (/BAD_MATCH/.test(m)) return 'camp.err.badMatch';
        if (/BAD_ENTRIES/.test(m)) return 'camp.err.badEntries';
        if (/CAMPAIGN_NOT_FOUND/.test(m)) return 'camp.err.notFound';
        if (/CLUB_NOT_WRITABLE|CLUB_NOT_FOUND/.test(m)) return 'camp.err.club';
        return 'camp.err.generic';
    }
    function _errMsg(error) {
        var raw = (error && (error.message || error.details)) || '';
        return _tt(_errKey(raw), raw || 'Error');
    }

    /* Grupează meciuri pe meta.campaignId. PUR (pentru self-test). */
    function _groupMatches(matches) {
        var out = {};
        (matches || []).forEach(function (m) {
            var cid = m && m.meta && m.meta.campaignId;
            if (!cid) return;
            (out[cid] = out[cid] || []).push(m);
        });
        Object.keys(out).forEach(function (k) {
            out[k].sort(function (a, b) { return new Date(a.date || 0) - new Date(b.date || 0); });
        });
        return out;
    }

    function _statusMeta(s) {
        if (s === 'completed') return { label: _tt('camp.completedF', 'Finalizată'), color: 'var(--success,#27ae60)' };
        if (s === 'abandoned') return { label: _tt('camp.abandoned', 'Abandonată'), color: '#888' };
        return { label: _tt('camp.inProgress', 'În desfășurare'), color: 'var(--accent-primary,#ff6b35)' };
    }

    /* Chip jucător: avatar + nume clickabil -> profil public (§11.6/§27.4). */
    function _chip(id) {
        var m = (typeof memberById === 'function') ? memberById(id) : (state.membersById && state.membersById[id]);
        // Rezolvă numele; dacă proprietarul nu mai e găsit (a plecat din club /
        // membru orfan / listă neîncărcată) NU afișăm UUID-ul brut (urât + scurgere de ID),
        // ci un placeholder prietenos. EN: friendly fallback instead of raw UUID.
        var resolved = (typeof displayNameById === 'function' && displayNameById(id)) || (m && m.name) || '';
        var name = resolved || _tt('camp.unknownMember', 'Membru necunoscut');
        var av = (typeof avatarHtml === 'function' && m) ? avatarHtml(m.avatar, 22) : '';
        return '<span class="camp-chip" onclick="TO_CAMP._openProfile(\'' + _ajs(id) + '\',\'' + _ajs(name) + '\')">' +
            '<span class="camp-chip-av">' + av + '</span><span class="camp-chip-name">' + _esc(name) + '</span></span>';
    }
    TC._openProfile = function (id, name) {
        if (typeof openPublicProfileById === 'function') openPublicProfileById(id, name);
    };

    /* ------------------------------------------------------------ RPC wrappers
       DB-first (§23.2): starea locală se atinge DOAR la succes; pe eroare return. */
    function _rpc(fn, args) {
        return sb.rpc(fn, args).then(function (res) {
            if (res.error) return { ok: false, error: res.error };
            return { ok: true, data: res.data };
        }).catch(function (e) { return { ok: false, error: e }; });
    }
    TC.create = function (payload) { return _rpc('campaign_create', { p_club_id: currentClubId, p_payload: payload }); };
    TC.update = function (id, payload) { return _rpc('campaign_update', { p_id: id, p_payload: payload }); };
    TC.setStatus = function (id, status) { return _rpc('campaign_set_status', { p_id: id, p_status: status }); };
    TC.del = function (id) { return _rpc('campaign_delete', { p_id: id }); };
    TC.upsertChar = function (campId, payload) { return _rpc('campaign_upsert_character', { p_campaign_id: campId, p_payload: payload }); };
    TC.retireChar = function (charId) { return _rpc('campaign_retire_character', { p_char_id: charId }); };
    TC.setWorldState = function (campId, patch) { return _rpc('campaign_set_world_state', { p_campaign_id: campId, p_patch: patch }); };
    TC.setProgress = function (campId, matchId, entries) { return _rpc('campaign_set_progress', { p_campaign_id: campId, p_match_id: String(matchId), p_entries: entries }); };
    TC.finalize = function (campId, awards) { return _rpc('campaign_finalize', { p_campaign_id: campId, p_awards: (awards && Object.keys(awards).length ? awards : null) }); };
    TC.reopenRpc = function (campId) { return _rpc('campaign_reopen', { p_campaign_id: campId }); };

    /* ---------------------------------------------------------------- fetch */
    TC.fetch = function () {
        if (_demo() || typeof sb === 'undefined' || !sb || !currentClubId) { _campCache = []; return Promise.resolve(); }
        return sb.from('campaigns').select('*').eq('club_id', currentClubId)
            .order('created_at', { ascending: false })
            .then(function (res) {
                if (res.error) { logError('camp.fetch', res.error); _campCache = []; return; }
                _campCache = res.data || [];
                _campClubId = currentClubId;
                _campUserId = _curUid();
                /* Mirror ușor în state.campaigns pentru badge-ul de tab (updateTabBadges). */
                state.campaigns = _campCache.map(function (c) { return { id: c.id, name: c.name, status: c.status, game: c.game_title }; });
                try { if (typeof updateTabBadges === 'function') updateTabBadges(); } catch (e) { logError('camp.badge', e); }
                var ids = _campCache.map(function (c) { return c.id; });
                /* Sesiuni legate: derivate din state.games (deja hidratat) — fără interogare
                   DB fragilă pe JSON path. Grupare pură pe meta.campaignId. */
                var linked = (state.games || []).filter(function (g) { return g && g.campaignId; }).map(function (g) {
                    return { id: g.id, game_title: g.gameName, date: g.timestamp, players: Array.isArray(g.participants) ? g.participants : [], winners: Array.isArray(g.winners) ? g.winners : [], meta: { campaignId: g.campaignId, scenarioName: g.scenarioName || null } };
                });
                _matchByCamp = _groupMatches(linked);
                if (!ids.length) { _charByCamp = {}; return; }
                /* Personaje active — sub-interogare izolată: dacă eșuează, lista de campanii
                   rămâne funcțională (nu respingem tot fetch-ul). */
                return sb.from('campaign_characters').select('campaign_id,profile_id,status')
                    .in('campaign_id', ids).eq('status', 'active')
                    .then(function (r) {
                        _charByCamp = {};
                        ((r && r.data) || []).forEach(function (ch) {
                            (_charByCamp[ch.campaign_id] = _charByCamp[ch.campaign_id] || []).push(ch.profile_id);
                        });
                    })
                    .catch(function (e) { logError('camp.fetch.chars', e); _charByCamp = {}; });
            });
    };

    /* ---------------------------------------------------------------- render */
    function renderCampaigns() {
        var box = document.getElementById('campaignsList'); if (!box) return;
        var btn = document.getElementById('newCampaignBtn');
        if (!planAllows('campaigns')) { box.innerHTML = featureLockNote('campaigns'); if (btn) btn.style.display = 'none'; return; }
        /* Butonul „Campanie nouă" doar pentru Moderator+ (campaign.manage). */
        if (btn) btn.style.display = _canManage() ? '' : 'none';
        if (_demo()) { box.innerHTML = '<p style="opacity:.7;">' + _esc(_tt('camp.demoNote', 'Campaniile necesită un cont real.')) + '</p>'; return; }
        /* Context schimbat (re-login pe alt cont, sau alt club) -> înapoi la listă,
           nu rămâne pe pagina de campanie a sesiunii anterioare. */
        if (_campUserId !== _curUid() || _campClubId !== currentClubId) { _openCampId = null; _journalOpen = false; _charsFull = {}; }
        if (!_campChannel || _campChannelUser !== _curUid()) { try { subscribeRealtimeCampaigns(); } catch (e) {} }
        box.innerHTML = '<p style="opacity:.6;">' + _esc(_tt('common.loading', 'Se încarcă…')) + '</p>';
        TC.fetch().then(function () {
            if (_openCampId) {
                if (!_campCache.some(function (x) { return String(x.id) === String(_openCampId); })) { _openCampId = null; _paint(); return; }
                return _loadCharsFull(_openCampId).then(function () { return _loadProgress(_openCampId); }).then(_paintDetail);
            }
            _paint();
        }).catch(function (e) { logError('renderCampaigns', e); _openCampId ? _paintDetail() : _paint(); });
    }

    function _paint() {
        var box = document.getElementById('campaignsList'); if (!box) return;
        _campMountHeaderTools();
        if (!_campCache.length) { box.innerHTML = '<p style="opacity:.7;">' + _esc(_tt('camp.noCampaigns', 'Nicio campanie încă.')) + '</p>'; return; }
        var q = (_campSearchQuery || '').trim().toLowerCase();
        var data = q ? _campCache.filter(function (c) {
            return (String(c.name || '').toLowerCase().indexOf(q) !== -1) ||
                   (String(c.game_title || '').toLowerCase().indexOf(q) !== -1) ||
                   (String(_statusMeta(c.status).label || '').toLowerCase().indexOf(q) !== -1);
        }) : _campCache;
        var manage = _canManage();
        if (!data.length) { box.innerHTML = '<p style="opacity:.7;">' + _esc(_tt('camp.searchEmpty', 'Nicio campanie găsită.')) + '</p>'; return; }
        box.innerHTML = data.map(function (c) {
            var sm = _statusMeta(c.status);
            var chars = _charByCamp[c.id] || [];
            var matches = _matchByCamp[c.id] || [];
            var sessionsLine = matches.length
                ? '<div class="camp-sessions">' + matches.slice().reverse().slice(0, 6).map(function (m) {
                    var d = m.date ? new Date(m.date).toLocaleDateString('en-GB') : '';
                    var n = Array.isArray(m.players) ? m.players.length : 0;
                    var scn = (m.meta && m.meta.scenarioName) ? (' — ' + _cesc(m.meta.scenarioName)) : '';
                    return '<div class="camp-session-row camp-session-click" onclick="TO_CAMP.openSession(\'' + _ajs(m.id) + '\')"><span class="camp-session-main">🎲 ' + _cesc(m.game_title || '') + scn + '</span>' +
                        '<span class="camp-session-meta">' + n + ' <i class="fas fa-users" style="opacity:.6;"></i> · <small>' + _esc(d) + '</small></span></div>';
                }).join('') + '</div>'
                : '<p class="camp-empty">' + _esc(_tt('camp.noLinkedSessions', 'Nicio sesiune legată încă.')) + '</p>';

            return '<div class="card camp-card" style="border-left:4px solid ' + sm.color + ';">' +
                '<div class="camp-head">' +
                    '<div style="min-width:0;">' +
                        '<h3 style="margin:0;"><a href="javascript:void(0)" onclick="TO_CAMP.openCampaign(\'' + _ajs(c.id) + '\')" style="color:inherit; text-decoration:none;">' + _cesc(c.name) + ' <i class="fas fa-chevron-right" style="font-size:.7em; opacity:.5;"></i></a></h3>' +
                        '<div class="camp-sub">' + (c.game_title ? '🎲 ' + _cesc(c.game_title) + ' • ' : '') +
                            '<span style="color:' + sm.color + ';">' + _esc(sm.label) + '</span></div>' +
                    '</div>' +
                    '<div class="camp-counts">' + matches.length + ' ' + _esc(_tt('camp.sessionsCount', 'sesiuni')) +
                        ' • ' + chars.length + ' ' + _esc(_tt('camp.charsActive', 'personaje active')) + '</div>' +
                '</div>' +
                (chars.length ? '<div class="camp-roster">' + chars.map(_chip).join('') + '</div>' : '') +
                sessionsLine +
                (manage ? '<div class="btn-group camp-actions">' +
                    (c.status === 'active' ? '<button class="btn btn-sm" onclick="TO_CAMP.startSession(\'' + _ajs(c.id) + '\')"><i class="fas fa-dice"></i> <span class="camp-btn-txt">' + _esc(_tt('camp.startSession', '+ Sesiune de campanie')) + '</span></button>' : '') +
                    '<button class="btn btn-sm btn-secondary" onclick="openCampaignEditor(\'' + _ajs(c.id) + '\')"><i class="fas fa-edit"></i> <span class="camp-btn-txt">' + _esc(_tt('history.edit', 'Editează')) + '</span></button>' +
                    '<button class="btn btn-sm btn-danger" onclick="deleteCampaign(\'' + _ajs(c.id) + '\')"><i class="fas fa-trash"></i></button>' +
                '</div>' : '') +
            '</div>';
        }).join('');
    }
    TC._paint = _paint;

    /* -------- Faza 5d: Search + Export (replică 1:1 după turnee) ---------------
       Butoane icon .tab-head-btn lângă „Campanie nouă" (Mod+) sau deasupra listei
       (membru). Pe mobil: butonul New devine icon-only, totul pe un rând orizontal. */
    function _campMountHeaderTools() {
        try {
            var host = document.getElementById('campaignsList');
            var manage = _canManage();
            var searchBtnHtml = '<button type="button" class="tab-head-btn" id="campTile-search" title="' + _esc(_tt('camp.search', 'Caută')) + '" aria-label="' + _esc(_tt('camp.search', 'Caută')) + '" onclick="TO_CAMP._campToggleSearch(this)"><i class="fas fa-search"></i></button>';
            var exportBtnHtml = '<button type="button" class="tab-head-btn" title="' + _esc(_tt('camp.export', 'Export')) + '" aria-label="' + _esc(_tt('camp.export', 'Export')) + '" onclick="TO_CAMP._campExport()"><i class="fas fa-file-export"></i></button>';

            if (!document.getElementById('campHeaderTools') && !document.getElementById('campListTools')) {
                if (!document.getElementById('campHeaderToolsCss')) {
                    var stl = document.createElement('style');
                    stl.id = 'campHeaderToolsCss';
                    stl.textContent =
                        '#campHeaderTools{display:inline-flex;gap:8px;align-items:center;flex-wrap:wrap;}' +
                        '#newCampaignBtn{display:none !important;}' +
                        '#campNewMobile{display:none;}' +
                        '@media(max-width:600px){#campNewDesktop{display:none;}#campNewMobile{display:inline-flex;}}';
                    document.head.appendChild(stl);
                }
                var newBtn = document.getElementById('newCampaignBtn');
                if (manage && newBtn && newBtn.parentNode) {
                    /* Moderator+: grup în header cu replica butonului New (desktop/mobil) + search + export */
                    var cls = newBtn.className || 'btn btn-sm';
                    var label = _tt('campaigns.new', 'Campanie nouă');
                    var wrap = document.createElement('span');
                    wrap.id = 'campHeaderTools';
                    wrap.innerHTML =
                        '<button type="button" id="campNewDesktop" class="' + _esc(cls) + '" onclick="openCampaignEditor()"><i class="fas fa-plus"></i> ' + _esc(label) + '</button>' +
                        '<button type="button" id="campNewMobile" class="tab-head-btn accent" title="' + _esc(label) + '" aria-label="' + _esc(label) + '" onclick="openCampaignEditor()"><i class="fas fa-plus"></i></button>' +
                        searchBtnHtml + exportBtnHtml;
                    newBtn.parentNode.insertBefore(wrap, newBtn.nextSibling);
                } else if (host && host.parentNode) {
                    /* Membru (fără buton New): doar search + export, aliniate dreapta deasupra listei */
                    var bar = document.createElement('div');
                    bar.id = 'campListTools';
                    bar.style.cssText = 'display:flex; justify-content:flex-end; gap:8px; margin-bottom:10px;';
                    bar.innerHTML = searchBtnHtml + exportBtnHtml;
                    host.parentNode.insertBefore(bar, host);
                }
            }
            /* panou de căutare (.sess-panel) — frate cu lista, deci input-ul păstrează focusul */
            if (host && host.parentNode && !document.getElementById('campPanel-search')) {
                var panel = document.createElement('div');
                panel.id = 'campPanel-search';
                panel.className = 'sess-panel hidden';
                panel.innerHTML =
                    '<label for="campSearchInput"><i class="fas fa-search"></i> ' + _esc(_tt('camp.search', 'Caută')) + '</label>' +
                    '<input type="search" id="campSearchInput" class="form-control" placeholder="' + _esc(_tt('camp.searchPh', 'Caută campanii…')) + '" oninput="TO_CAMP._campSearchInput(this.value)">';
                host.parentNode.insertBefore(panel, host);
            }
            return true;
        } catch (e) { logError('camp.mountTools', e); return false; }
    }

    TC._campToggleSearch = function (btn) {
        try {
            if (typeof toggleTilePanel === 'function') toggleTilePanel('campPanel-search', btn);
            else { var p0 = document.getElementById('campPanel-search'); if (p0) p0.classList.toggle('hidden'); }
        } catch (e) {}
        var panel = document.getElementById('campPanel-search');
        var inp = document.getElementById('campSearchInput');
        var open = panel && !panel.classList.contains('hidden');
        _campSearchOpen = !!open;
        if (open) { if (inp) { try { inp.focus(); } catch (e) {} } }
        else { if (inp) inp.value = ''; _campSearchQuery = ''; _paint(); }
    };

    TC._campSearchInput = function (v) {
        _campSearchQuery = v || '';
        _paint(); /* panoul e frate cu lista -> input-ul își păstrează focusul */
    };

    /* Export campanii curente (respectă filtrul de căutare). .xlsx real; fallback CSV sep=; */
    TC._campExport = async function () {
        try {
            /* Batch 2: SheetJS nu mai e încărcat la pornire — îl aducem acum.
               Dacă încărcarea eșuează, NU afișăm eroare: codul de mai jos are deja
               fallback pe CSV, deci utilizatorul primește tot un fișier. */
            try { await window.ensureLib('xlsx'); } catch (e) { }
            var q = (_campSearchQuery || '').trim().toLowerCase();
            var list = _campCache.filter(function (c) {
                if (!q) return true;
                return (String(c.name || '').toLowerCase().indexOf(q) !== -1) ||
                       (String(c.game_title || '').toLowerCase().indexOf(q) !== -1) ||
                       (String(_statusMeta(c.status).label || '').toLowerCase().indexOf(q) !== -1);
            });
            if (!list.length) { showNotification(_tt('camp.exportEmpty', 'Nimic de exportat.'), 'error'); return; }

            var head = [
                _tt('camp.exp.name', 'Nume'), _tt('camp.exp.game', 'Joc'), _tt('camp.exp.status', 'Stare'),
                _tt('camp.sessionsCount', 'sesiuni'), _tt('camp.charsActive', 'personaje active'), _tt('camp.exp.created', 'Creată')
            ];
            function dateStr(v) { if (!v) return ''; try { return new Date(v).toLocaleDateString(); } catch (e) { return String(v); } }
            var rows = list.map(function (c) {
                return [
                    c.name || '', c.game_title || '', _statusMeta(c.status).label,
                    ((_matchByCamp[c.id] || []).length),
                    ((_charByCamp[c.id] || []).length),
                    dateStr(c.created_at)
                ];
            });
            var aoa = [head].concat(rows);
            var fname = 'campanii-' + new Date().toISOString().slice(0, 10);

            var XLSX = (typeof window !== 'undefined') ? window.XLSX : null;
            if (XLSX && XLSX.utils) {
                var ws = XLSX.utils.aoa_to_sheet(aoa);
                ws['!cols'] = [{ wch: 26 }, { wch: 18 }, { wch: 16 }, { wch: 10 }, { wch: 16 }, { wch: 14 }];
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Campanii');
                var arr = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
                _campDownloadBlob(new Blob([arr], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fname + '.xlsx');
                return;
            }
            function esc(v) { v = (v == null) ? '' : String(v); return /[";\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; }
            var csv = '\ufeffsep=;\n' + aoa.map(function (r) { return r.map(esc).join(';'); }).join('\n');
            _campDownloadBlob(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), fname + '.csv');
        } catch (e) { logError('camp.export', e); showNotification(_tt('camp.err.generic', 'A apărut o eroare.'), 'error'); }
    };

    function _campDownloadBlob(blob, filename) {
        try {
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url; a.download = filename;
            document.body.appendChild(a); a.click();
            setTimeout(function () { try { document.body.removeChild(a); URL.revokeObjectURL(url); } catch (e) {} }, 0);
        } catch (e) { logError('camp.downloadBlob', e); }
    }

    /* =====================================================================
       FAZA 3a — PAGINĂ DEDICATĂ DE CAMPANIE + FIȘE DE PERSONAJ
       ===================================================================== */
    TC.openCampaign = function (id) { _openCampId = id; _journalOpen = false; renderCampaigns(); };
    TC.backToList = function () { _openCampId = null; renderCampaigns(); };

    /* Încarcă fișele COMPLETE (active + retrase) ale unei campanii. Izolat: pe
       eroare nu blochează pagina. RLS SELECT = membru club. */
    function _loadCharsFull(campId) {
        if (_demo() || typeof sb === 'undefined' || !sb) { _charsFull[campId] = []; return Promise.resolve(); }
        return sb.from('campaign_characters').select('*').eq('campaign_id', campId)
            .order('status', { ascending: true }).order('char_name', { ascending: true })
            .then(function (r) { _charsFull[campId] = (r && r.data) || []; })
            .catch(function (e) { logError('camp.loadChars', e); _charsFull[campId] = []; });
    }

    /* Jurnal de progresie (XP/aur/nivel per sesiune × personaj) pentru o campanie. */
    function _loadProgress(campId) {
        if (_demo() || typeof sb === 'undefined' || !sb) { _progByMatch = {}; return Promise.resolve(); }
        return sb.from('campaign_char_progress').select('match_id,char_id,xp,gold,level').eq('campaign_id', campId)
            .then(function (r) {
                _progByMatch = {};
                ((r && r.data) || []).forEach(function (p) {
                    (_progByMatch[p.match_id] = _progByMatch[p.match_id] || {})[p.char_id] = { xp: p.xp, gold: p.gold, level: p.level };
                });
            })
            .catch(function (e) { logError('camp.loadProgress', e); _progByMatch = {}; });
    }

    function _num(v, d) { var n = Number(v); return isFinite(n) ? n : (d || 0); }

    /* Card fișă de personaj (activ). */
    function _charCard(ch, manage, uid) {
        var mine = ch.profile_id === uid;
        var owner = _chip(ch.profile_id);
        var canEdit = mine || manage;
        var det = [];
        if (ch.equipment_notes) det.push('<div><strong>' + _esc(_tt('camp.f.equipment', 'Echipament')) + ':</strong> ' + _cesc(ch.equipment_notes) + '</div>');
        if (ch.personal_quest) det.push('<div><strong>' + _esc(_tt('camp.f.quest', 'Quest personal')) + ':</strong> ' + _cesc(ch.personal_quest) + '</div>');
        if (ch.notes) det.push('<div><strong>' + _esc(_tt('camp.f.notes', 'Notițe')) + ':</strong> ' + _cesc(ch.notes) + '</div>');
        return '<div class="camp-char-card">' +
            '<div class="camp-char-top">' +
                '<div style="min-width:0;">' +
                    '<div class="camp-char-name">' + _cesc(ch.char_name) + (mine ? ' <span class="camp-char-you">' + _esc(_tt('camp.you', 'tu')) + '</span>' : '') + '</div>' +
                    (ch.char_class ? '<div class="camp-char-class">' + _cesc(ch.char_class) + '</div>' : '') +
                    '<div class="camp-char-owner">' + owner + '</div>' +
                '</div>' +
                '<div class="camp-char-stats">' +
                    '<span title="' + _esc(_tt('camp.f.level', 'Nivel')) + '">' + _esc(_tt('camp.lvl', 'Nv.')) + ' ' + _num(ch.level, 1) + '</span>' +
                    '<span title="' + _esc(_tt('camp.f.xp', 'XP')) + '">✨ ' + _num(ch.xp, 0) + '</span>' +
                    '<span title="' + _esc(_tt('camp.f.gold', 'Aur')) + '">🪙 ' + _num(ch.gold, 0) + '</span>' +
                '</div>' +
            '</div>' +
            (det.length ? '<div class="camp-char-det">' + det.join('') + '</div>' : '') +
            (canEdit ? '<div class="camp-char-actions">' +
                '<button class="btn btn-sm btn-secondary" onclick="TO_CAMP.openCharEditor(\'' + _ajs(_openCampId) + '\',\'' + _ajs(ch.id) + '\')"><i class="fas fa-edit"></i> ' + _esc(_tt('common.edit', 'Editează')) + '</button>' +
                '<button class="btn btn-sm btn-danger" onclick="TO_CAMP.retireCharacter(\'' + _ajs(ch.id) + '\',\'' + _ajs(ch.char_name) + '\')"><i class="fas fa-user-slash"></i> ' + _esc(_tt('camp.retireCharBtn', 'Retrage')) + '</button>' +
            '</div>' : '') +
        '</div>';
    }

    /* ---- World State (panou): note, contoare, deblocări, realizări ---- */
    function _wsData(c) {
        var ws = (c && c.world_state && typeof c.world_state === 'object') ? c.world_state : {};
        return {
            notes: ws.notes || '',
            counters: (ws.counters && typeof ws.counters === 'object' && !Array.isArray(ws.counters)) ? ws.counters : {},
            unlocks: Array.isArray(ws.unlocks) ? ws.unlocks : [],
            achievements: Array.isArray(ws.achievements) ? ws.achievements : []
        };
    }
    function _worldStateBlock(c, manage) {
        var w = _wsData(c);
        var ckeys = Object.keys(w.counters);
        var empty = !w.notes && !ckeys.length && !w.unlocks.length && !w.achievements.length;
        var body;
        if (empty) {
            body = '<p class="camp-empty">' + _esc(_tt('camp.ws.empty', 'Nimic în starea lumii încă.')) + '</p>';
        } else {
            body = '';
            if (ckeys.length) body += '<div class="camp-ws-counters">' + ckeys.map(function (k) {
                return '<span class="camp-ws-counter">' + _cesc(k) + ': <strong>' + _cesc(String(w.counters[k])) + '</strong></span>';
            }).join('') + '</div>';
            if (w.unlocks.length) body += '<div class="camp-ws-list"><div class="camp-ws-lbl">' + _esc(_tt('camp.ws.unlocks', 'Deblocări')) + '</div><ul>' +
                w.unlocks.map(function (x) { return '<li>🔓 ' + _cesc(String(x)) + '</li>'; }).join('') + '</ul></div>';
            if (w.achievements.length) body += '<div class="camp-ws-list"><div class="camp-ws-lbl">' + _esc(_tt('camp.ws.achievements', 'Realizări')) + '</div><ul>' +
                w.achievements.map(function (x) { return '<li>🏆 ' + _cesc(String(x)) + '</li>'; }).join('') + '</ul></div>';
            if (w.notes) body += '<div class="camp-ws-notes">' + _cesc(w.notes) + '</div>';
        }
        return '<div class="camp-section"><h3><i class="fas fa-earth-europe"></i> ' + _esc(_tt('camp.ws.title', 'Starea lumii')) +
            (manage ? ' <button class="btn btn-sm btn-secondary" style="width:auto; margin-left:auto;" onclick="TO_CAMP.openWorldState(\'' + _ajs(c.id) + '\')"><i class="fas fa-pen"></i> ' + _esc(_tt('common.edit', 'Editează')) + '</button>' : '') +
            '</h3>' + body + '</div>';
    }

    function _paintDetail() {
        var box = document.getElementById('campaignsList'); if (!box) return;
        var c = _campCache.find(function (x) { return String(x.id) === String(_openCampId); });
        if (!c) { _openCampId = null; _paint(); return; }
        var manage = _canManage();
        var uid = _curUid();
        var sm = _statusMeta(c.status);
        var all = _charsFull[c.id] || [];
        var active = all.filter(function (x) { return x.status === 'active'; });
        var retired = all.filter(function (x) { return x.status === 'retired'; });
        var iHaveActive = !!active.find(function (x) { return x.profile_id === uid; });
        var matches = _matchByCamp[c.id] || [];

        var head = '<div class="camp-detail-head">' +
            '<button class="btn btn-sm btn-secondary" onclick="TO_CAMP.backToList()"><i class="fas fa-arrow-left"></i> <span class="camp-btn-txt">' + _esc(_tt('camp.back', 'Înapoi')) + '</span></button>' +
            (manage ? '<div class="btn-group camp-detail-actions">' +
                (c.status === 'active' ? '<button class="btn btn-sm" onclick="TO_CAMP.startSession(\'' + _ajs(c.id) + '\')"><i class="fas fa-dice"></i> <span class="camp-btn-txt">' + _esc(_tt('camp.startSession', '+ Sesiune')) + '</span></button>' : '') +
                '<button class="btn btn-sm btn-secondary" onclick="openCampaignEditor(\'' + _ajs(c.id) + '\')"><i class="fas fa-edit"></i></button>' +
                (c.status === 'active' ? '<button class="btn btn-sm btn-success camp-finalize-btn" onclick="TO_CAMP.openFinalize(\'' + _ajs(c.id) + '\')"><i class="fas fa-flag-checkered"></i> <span class="camp-btn-txt">' + _esc(_tt('camp.finalize', 'Finalizează')) + '</span></button>' : '') +
                (c.status === 'completed' && _canAward(c) ? '<button class="btn btn-sm btn-secondary" onclick="TO_CAMP.reopen(\'' + _ajs(c.id) + '\')"><i class="fas fa-rotate-left"></i> <span class="camp-btn-txt">' + _esc(_tt('camp.reopen', 'Redeschide')) + '</span></button>' : '') +
                '<button class="btn btn-sm btn-danger" onclick="deleteCampaign(\'' + _ajs(c.id) + '\')"><i class="fas fa-trash"></i></button>' +
            '</div>' : '') +
        '</div>';

        var title = '<div class="camp-detail-title" style="border-left:4px solid ' + sm.color + ';">' +
            '<h2 style="margin:0;">' + _cesc(c.name) + '</h2>' +
            '<div class="camp-sub">' + (c.game_title ? '🎲 ' + _cesc(c.game_title) + ' • ' : '') +
                '<span style="color:' + sm.color + ';">' + _esc(sm.label) + '</span> • ' +
                matches.length + ' ' + _esc(_tt('camp.sessionsCount', 'sesiuni')) + '</div>' +
        '</div>';

        var addBtns = '';
        if (!_demo()) {
            if (!iHaveActive && uid) addBtns += '<button class="btn btn-sm" onclick="TO_CAMP.openCharEditor(\'' + _ajs(c.id) + '\')"><i class="fas fa-user-plus"></i> ' + _esc(_tt('camp.addMyChar', '+ Personajul meu')) + '</button> ';
            if (manage) addBtns += '<button class="btn btn-sm btn-secondary" onclick="TO_CAMP.openCharEditor(\'' + _ajs(c.id) + '\',\'\',\'__pick__\')"><i class="fas fa-users"></i> ' + _esc(_tt('camp.addCharOther', '+ Personaj (membru)')) + '</button>';
        }

        var charsBlock = '<div class="camp-section"><h3><i class="fas fa-users"></i> ' + _esc(_tt('camp.charactersTitle', 'Personaje')) + '</h3>' +
            (active.length ? '<div class="camp-char-grid">' + active.map(function (ch) { return _charCard(ch, manage, uid); }).join('') + '</div>'
                           : '<p class="camp-empty">' + _esc(_tt('camp.noChars', 'Niciun personaj activ încă.')) + '</p>') +
            (addBtns ? '<div class="camp-add-row">' + addBtns + '</div>' : '') +
            (retired.length ? '<details class="camp-retired"><summary>' + _esc(_tt('camp.retiredTitle', 'Personaje retrase')) + ' (' + retired.length + ')</summary>' +
                '<div class="camp-char-grid">' + retired.map(function (ch) {
                    return '<div class="camp-char-card retired"><div class="camp-char-name">' + _cesc(ch.char_name) + '</div>' +
                        (ch.char_class ? '<div class="camp-char-class">' + _cesc(ch.char_class) + '</div>' : '') +
                        '<div class="camp-char-owner">' + _chip(ch.profile_id) + '</div>' +
                        '<div class="camp-char-stats"><span>' + _esc(_tt('camp.lvl', 'Nv.')) + ' ' + _num(ch.level, 1) + '</span></div></div>';
                }).join('') + '</div></details>' : '') +
        '</div>';

        /* Jurnal cronologic (recent -> vechi), cu „Arată mai multe". */
        var LIMIT = 5;
        var ordered = matches.slice().reverse();
        var shown = _journalOpen ? ordered : ordered.slice(0, LIMIT);
        var sessBlock = '<div class="camp-section"><h3><i class="fas fa-scroll"></i> ' + _esc(_tt('camp.linkedSessions', 'Sesiuni legate')) + '</h3>' +
            (ordered.length ? '<div class="camp-sessions">' + shown.map(function (m) {
                var d = m.date ? new Date(m.date).toLocaleDateString('en-GB') : '';
                var n = Array.isArray(m.players) ? m.players.length : 0;
                var scn = (m.meta && m.meta.scenarioName) ? (' — ' + _cesc(m.meta.scenarioName)) : '';
                var hasProg = _progByMatch[String(m.id)] && Object.keys(_progByMatch[String(m.id)]).length;
                var progInd = hasProg ? '<span class="camp-prog-ind" title="' + _esc(_tt('camp.prog.has', 'Progresie înregistrată')) + '">✨</span>' : '';
                var progBtn = manage ? '<button type="button" class="btn btn-sm btn-secondary camp-prog-btn" onclick="event.stopPropagation(); TO_CAMP.openProgress(\'' + _ajs(_openCampId) + '\',\'' + _ajs(m.id) + '\')"><i class="fas fa-wand-magic-sparkles"></i> <span class="camp-prog-btn-txt">' + _esc(_tt('camp.prog.btn', 'XP/Aur')) + '</span></button>' : '';
                return '<div class="camp-session-row camp-session-click" onclick="TO_CAMP.openSession(\'' + _ajs(m.id) + '\')"><span class="camp-session-main">🎲 ' + _cesc(m.game_title || '') + scn + ' ' + progInd + '</span>' +
                    '<span class="camp-session-meta">' + progBtn + '<span class="camp-session-metaN">' + n + ' <i class="fas fa-users" style="opacity:.6;"></i> · <small>' + _esc(d) + '</small></span></span></div>';
            }).join('') + '</div>' +
                (ordered.length > LIMIT ? '<button class="btn btn-sm btn-secondary camp-showmore" onclick="TO_CAMP.toggleJournal()">' +
                    (_journalOpen ? _esc(_tt('camp.showLess', 'Arată mai puține')) : _esc(_tt('camp.showMore', 'Arată mai multe')) + ' (' + (ordered.length - LIMIT) + ')') + '</button>' : '')
                : '<p class="camp-empty">' + _esc(_tt('camp.noLinkedSessions', 'Nicio sesiune legată încă.')) + '</p>') +
        '</div>';

        box.innerHTML = '<div class="camp-detail">' + head + title + _worldStateBlock(c, manage) + charsBlock + sessBlock + '</div>';
    }
    TC._paintDetail = _paintDetail;
    TC.toggleJournal = function () { _journalOpen = !_journalOpen; _paintDetail(); };

    /* Popup detaliu sesiune legată — reutilizează renderHistoryCard (card complet:
       scoruri, badge-uri, note, poze, meta). Fără butoanele de acțiune (read-only). */
    TC.openSession = function (matchId) {
        var g = (state.games || []).find(function (x) { return String(x.id) === String(matchId); });
        if (!g) { showNotification(_tt('camp.err.notFound', 'Sesiunea nu a fost găsită.'), 'error'); return; }
        if (typeof renderHistoryCard !== 'function') { showNotification(_tt('camp.err.generic', 'A apărut o eroare.'), 'error'); return; }
        var modal = document.createElement('div');
        modal.className = 'modal active camp-session-modal';
        modal.innerHTML = '<div class="modal-content" style="max-width:640px; padding-top:46px;">' +
            '<button class="modal-close" style="position:absolute; top:12px; right:14px; z-index:2;" onclick="this.closest(\'.modal\').remove()">×</button>' +
            renderHistoryCard(g) +
        '</div>';
        var acts = modal.querySelector('.hist-actions'); if (acts) acts.remove();  // read-only în popup
        document.body.appendChild(modal);
    };

    /* ---- Progresie personaje pentru o sesiune (Mod+): XP/aur/nivel câștigate.
       Valori ABSOLUTE pentru sesiune; RPC-ul aplică diferența pe fișă (idempotent). ---- */
    TC.openProgress = function (campId, matchId) {
        if (!requireFeature('campaigns')) return;
        if (!_canManage()) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        document.querySelectorAll('.modal[data-prog-modal]').forEach(function (m) { m.remove(); });
        var active = (_charsFull[campId] || []).filter(function (x) { return x.status === 'active'; });
        if (!active.length) { showNotification(_tt('camp.prog.noChars', 'Niciun personaj activ pentru progresie.'), 'error'); return; }
        var m = (_matchByCamp[campId] || []).find(function (x) { return String(x.id) === String(matchId); }) || {};
        var d = m.date ? new Date(m.date).toLocaleDateString('en-GB') : '';
        var prog = _progByMatch[String(matchId)] || {};
        var uid = _curUid();
        function inp(id, cls, val) { return '<input type="number" class="form-control ' + cls + '" value="' + _esc(val == null ? '' : String(val)) + '" style="text-align:center;">'; }
        var rows = active.map(function (ch) {
            var p = prog[ch.id] || {};
            return '<div class="camp-prog-row" data-char="' + _esc(ch.id) + '">' +
                '<div class="camp-prog-who"><div class="camp-prog-name">' + _cesc(ch.char_name) + (ch.profile_id === uid ? ' <span class="camp-char-you">' + _esc(_tt('camp.you', 'tu')) + '</span>' : '') + '</div>' +
                    '<div class="camp-prog-owner">' + _chip(ch.profile_id) + '</div></div>' +
                '<div class="camp-prog-fields">' +
                    '<label>✨<br>' + inp('', 'prog-xp', p.xp) + '</label>' +
                    '<label>🪙<br>' + inp('', 'prog-gold', p.gold) + '</label>' +
                    '<label>' + _esc(_tt('camp.lvl', 'Nv.')) + '<br>' + inp('', 'prog-lvl', p.level) + '</label>' +
                '</div>' +
            '</div>';
        }).join('');
        var modal = document.createElement('div');
        modal.className = 'modal active';
        modal.dataset.progModal = '1';
        modal.dataset.campId = campId;
        modal.dataset.matchId = String(matchId);
        modal.innerHTML = '<div class="modal-content"><div class="modal-header">' +
            '<h2><i class="fas fa-wand-magic-sparkles"></i> ' + _esc(_tt('camp.prog.title', 'Progresie personaje')) + '</h2>' +
            '<button class="modal-close" onclick="this.closest(\'.modal\').remove()">×</button></div>' +
            '<div class="camp-sub" style="margin-bottom:10px;">🎲 ' + _cesc(m.game_title || '') + (d ? ' • ' + _esc(d) : '') + '</div>' +
            '<small style="display:block; color:var(--text-secondary); margin-bottom:12px;">' + _esc(_tt('camp.prog.hint', 'Valori câștigate în această sesiune (in-ficțiune).')) + '</small>' +
            '<div class="camp-prog-list">' + rows + '</div>' +
            '<button class="btn btn-primary" style="margin-top:14px;" onclick="TO_CAMP.saveProgress()"><i class="fas fa-save"></i> ' + _esc(_tt('common.save', 'Salvează')) + '</button>' +
        '</div>';
        document.body.appendChild(modal);
    };

    TC.saveProgress = async function () {
        var modal = document.querySelector('.modal.active[data-prog-modal]');
        if (!modal) return;
        var campId = modal.dataset.campId;
        var matchId = modal.dataset.matchId;
        var prev = _progByMatch[String(matchId)] || {};
        var entries = [];
        modal.querySelectorAll('.camp-prog-row').forEach(function (row) {
            var charId = row.dataset.char;
            var xp = _num(row.querySelector('.prog-xp').value, 0);
            var gold = _num(row.querySelector('.prog-gold').value, 0);
            var lvl = _num(row.querySelector('.prog-lvl').value, 0);
            /* Includem rândul dacă are valori sau dacă exista deja o intrare (ca să
               poți reduce/anula progresia unei sesiuni). */
            if (xp || gold || lvl || prev[charId]) entries.push({ char_id: charId, xp: xp, gold: gold, level: lvl });
        });
        if (!entries.length) { modal.remove(); return; }
        var res = await TC.setProgress(campId, matchId, entries);
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }
        modal.remove();
        try { await _loadCharsFull(campId); await _loadProgress(campId); } catch (e) { logError('camp.progRefresh', e); }
        _paintDetail();
        showNotification(_tt('camp.prog.saved', 'Progresie salvată.'), 'success');
    };

    /* ---- Faza 5: Finalizare campanie + distribuție Puncte de Club (Admin) ---- */
    TC.openFinalize = function (campId) {
        if (!requireFeature('campaigns')) return;
        if (!_canManage()) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        var c = _campCache.find(function (x) { return String(x.id) === String(campId); });
        if (!c || c.status !== 'active') { showNotification(_tt('camp.err.badTransition', 'Campania nu poate fi finalizată acum.'), 'error'); return; }
        document.querySelectorAll('.modal[data-finalize-modal]').forEach(function (m) { m.remove(); });
        var admin = _canAward(c); /* Admin SAU creatorul campaniei (chiar moderator). */
        /* Participanți = proprietarii personajelor (activi + retrași), distinct. */
        var seen = {}, parts = [];
        (_charsFull[campId] || []).forEach(function (ch) {
            if (ch.profile_id && !seen[ch.profile_id]) { seen[ch.profile_id] = 1; parts.push(ch.profile_id); }
        });
        var awardsUi;
        if (admin) {
            awardsUi = parts.length
                ? '<div class="camp-final-awards">' + parts.map(function (pid) {
                    return '<div class="camp-final-row" data-pid="' + _esc(pid) + '">' +
                        '<div class="camp-final-who">' + _chip(pid) + '</div>' +
                        '<label class="camp-final-pts">🏆 <input type="number" class="form-control final-pts" value="" placeholder="0" style="width:92px;text-align:center;"></label>' +
                    '</div>';
                }).join('') + '</div>'
                : '<p class="camp-empty">' + _esc(_tt('camp.final.noParts', 'Niciun participant cu personaj.')) + '</p>';
        } else {
            awardsUi = '<p class="camp-final-note">' + _esc(_tt('camp.final.modOnly', 'Vei marca campania ca finalizată. Distribuția de Puncte de Club necesită un Administrator.')) + '</p>';
        }
        var modal = document.createElement('div');
        modal.className = 'modal active';
        modal.dataset.finalizeModal = '1';
        modal.dataset.campId = campId;
        modal.innerHTML = '<div class="modal-content"><div class="modal-header">' +
            '<h2><i class="fas fa-flag-checkered"></i> ' + _esc(_tt('camp.final.title', 'Finalizează campania')) + '</h2>' +
            '<button class="modal-close" onclick="this.closest(\'.modal\').remove()">×</button></div>' +
            '<div class="camp-sub" style="margin-bottom:10px;">' + _cesc(c.name) + '</div>' +
            (admin ? '<small style="display:block;color:var(--text-secondary);margin-bottom:12px;">' + _esc(_tt('camp.final.hint', 'Opțional: Puncte de Club acordate la finalizare (reversibile la redeschidere).')) + '</small>' : '') +
            awardsUi +
            '<button class="btn btn-primary" style="margin-top:14px;" onclick="TO_CAMP.saveFinalize()"><i class="fas fa-flag-checkered"></i> ' + _esc(_tt('camp.finalize', 'Finalizează')) + '</button>' +
        '</div>';
        document.body.appendChild(modal);
    };

    TC.saveFinalize = async function () {
        var modal = document.querySelector('.modal.active[data-finalize-modal]');
        if (!modal) return;
        var campId = modal.dataset.campId;
        var awards = {};
        modal.querySelectorAll('.camp-final-row').forEach(function (row) {
            var pid = row.dataset.pid;
            var pts = _num(row.querySelector('.final-pts').value, 0);
            if (pid && pts) awards[pid] = pts;
        });
        var btn = modal.querySelector('.btn-primary'); if (btn) btn.disabled = true;
        var res = await TC.finalize(campId, awards);
        if (!res.ok) { if (btn) btn.disabled = false; showNotification(_errMsg(res.error), 'error'); return; }
        modal.remove();
        try { await TC.fetch(); } catch (e) { logError('camp.finalRefresh', e); }
        _paintDetail();
        try { if (typeof scheduleRealtimeRefresh === 'function') scheduleRealtimeRefresh(); } catch (e) { logError('camp.finalStandings', e); }
        showNotification(_tt('camp.final.done', 'Campanie finalizată.'), 'success');
        /* Notificare „campanie finalizată" către ceilalți membri (ca la turnee: finalizare→membri). */
        try {
            var _cF = _campCache.find(function (x) { return String(x.id) === String(campId); });
            _campNotify(_campMemberIds(), campId, _campNotifText('camp.notif.finalized', 'Campaign completed: {name}', _cF ? _cF.name : ''), 'fa-flag-checkered');
        } catch (e) { logError('camp.notifFinal', e); }
    };

    TC.reopen = async function (campId) {
        var c = _campCache.find(function (x) { return String(x.id) === String(campId); });
        if (!_canAward(c)) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        var nm = c ? c.name : '';
        if (!await confirmModal(_tt('camp.reopen.confirm', 'Redeschizi campania „{name}"? Punctele finale acordate vor fi reversate.').replace('{name}', nm))) return;
        var res = await TC.reopenRpc(campId);
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }
        try { await TC.fetch(); } catch (e) { logError('camp.reopenRefresh', e); }
        _paintDetail();
        try { if (typeof scheduleRealtimeRefresh === 'function') scheduleRealtimeRefresh(); } catch (e) { logError('camp.reopenStandings', e); }
        showNotification(_tt('camp.reopen.done', 'Campanie redeschisă.'), 'success');
    };

    /* ---- Editor fișă de personaj (self ; sau Mod+ pentru alt membru) ---- */
    TC.openCharEditor = function (campId, charId, forPid) {
        if (!requireFeature('campaigns')) return;
        /* Anti-contaminare: elimină orice editor de personaj rămas în DOM (id-uri
           duplicate ar face getElementById să citească din modalul greșit). */
        document.querySelectorAll('.modal[data-char-modal]').forEach(function (m) { m.remove(); });
        var uid = _curUid();
        var manage = _canManage();
        var pickMode = (forPid === '__pick__');
        var ch = charId ? (_charsFull[campId] || []).find(function (x) { return String(x.id) === String(charId); }) : null;
        if (ch) forPid = ch.profile_id;              // editare: proprietarul fișei
        else if (pickMode) forPid = '';              // adăugare pt. alt membru (picker)
        else forPid = forPid || uid;                 // adăugare proprie
        /* Permisiuni client (RPC re-verifică server-side): editezi/adaugi doar propria fișă,
           sau orice fișă dacă ești Mod+. */
        var editingOther = (forPid && forPid !== uid);
        if ((editingOther || pickMode) && !manage) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }

        var picker = (pickMode && manage) ? ('<div class="form-group"><label for="charMemberSearch">' + _esc(_tt('camp.f.member', 'Membru')) + '</label>' +
            '<input type="hidden" id="charMemberId" value="">' +
            '<div id="charMemberSelected" style="display:none;"></div>' +
            '<div id="charMemberPicker">' +
                '<input type="text" id="charMemberSearch" class="form-control" autocomplete="off" placeholder="' + _esc(_tt('camp.f.memberSearchPh', 'Caută membru…')) + '" oninput="TO_CAMP.memberSearchLive()" onfocus="TO_CAMP.memberSearchLive()">' +
                '<div id="charMemberList" class="camp-member-list" style="display:none;"></div>' +
            '</div></div>') : '';

        function g(k, d) { return ch && ch[k] != null ? ch[k] : (d != null ? d : ''); }
        var modal = document.createElement('div');
        modal.className = 'modal active';
        modal.dataset.charModal = '1';
        modal.dataset.campId = campId;
        modal.dataset.charId = charId || '';
        modal.dataset.forPid = forPid || '';
        modal.innerHTML = '<div class="modal-content"><div class="modal-header">' +
            '<h2><i class="fas fa-user-shield"></i> ' + _esc(ch ? _tt('camp.editChar', 'Editează personaj') : _tt('camp.newChar', 'Personaj nou')) + '</h2>' +
            '<button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button></div>' +
            picker +
            '<div class="form-group"><label for="charName">' + _esc(_tt('camp.f.name', 'Nume personaj')) + '</label>' +
                '<input type="text" id="charName" class="form-control" value="' + _esc(g('char_name')) + '" placeholder="' + _esc(_tt('camp.f.namePh', 'Ex: Brute')) + '"></div>' +
            '<div class="form-group"><label for="charClass">' + _esc(_tt('camp.f.class', 'Clasă')) + '</label>' +
                '<input type="text" id="charClass" class="form-control" value="' + _esc(g('char_class')) + '" placeholder="' + _esc(_tt('camp.f.classPh', 'Ex: Inox')) + '"></div>' +
            '<div class="form-row">' +
                '<div class="form-group"><label for="charLevel">' + _esc(_tt('camp.f.level', 'Nivel')) + '</label><input type="number" id="charLevel" class="form-control" value="' + _esc(g('level', 1)) + '" min="1"></div>' +
                '<div class="form-group"><label for="charXp">' + _esc(_tt('camp.f.xp', 'XP (in-ficțiune)')) + '</label><input type="number" id="charXp" class="form-control" value="' + _esc(g('xp', 0)) + '"></div>' +
                '<div class="form-group"><label for="charGold">' + _esc(_tt('camp.f.gold', 'Aur')) + '</label><input type="number" id="charGold" class="form-control" value="' + _esc(g('gold', 0)) + '"></div>' +
            '</div>' +
            '<div class="form-group"><label for="charEquip">' + _esc(_tt('camp.f.equipment', 'Echipament')) + '</label><textarea id="charEquip" class="form-control" rows="2">' + _esc(g('equipment_notes')) + '</textarea></div>' +
            '<div class="form-group"><label for="charQuest">' + _esc(_tt('camp.f.quest', 'Quest personal')) + '</label><input type="text" id="charQuest" class="form-control" value="' + _esc(g('personal_quest')) + '"></div>' +
            '<div class="form-group"><label for="charNotes">' + _esc(_tt('camp.f.notes', 'Notițe')) + '</label><textarea id="charNotes" class="form-control" rows="2">' + _esc(g('notes')) + '</textarea></div>' +
            '<small style="color:var(--text-secondary); display:block; margin-bottom:10px;">' + _esc(_tt('camp.xpNote', 'XP-ul de campanie e in-ficțiune, separat de XP-ul de profil.')) + '</small>' +
            '<button class="btn btn-primary" onclick="TO_CAMP.saveChar()"><i class="fas fa-save"></i> ' + _esc(_tt('common.save', 'Salvează')) + '</button>' +
        '</div>';
        document.body.appendChild(modal);
    };

    TC.saveChar = async function () {
        var modal = document.querySelector('.modal.active[data-char-modal]');
        if (!modal) return;
        var campId = modal.dataset.campId;
        var charId = modal.dataset.charId || '';
        var uid = _curUid();
        var q = function (sel) { return modal.querySelector(sel); };
        var name = (q('#charName').value || '').trim();
        if (!name) { showNotification(_tt('camp.err.name', 'Dă un nume personajului.'), 'error'); return; }
        var payload = {
            char_name: name,
            char_class: (q('#charClass').value || '').trim() || null,
            level: _num(q('#charLevel').value, 1),
            xp: _num(q('#charXp').value, 0),
            gold: _num(q('#charGold').value, 0),
            equipment_notes: (q('#charEquip').value || '').trim() || null,
            personal_quest: (q('#charQuest').value || '').trim() || null,
            notes: (q('#charNotes').value || '').trim() || null
        };
        var pid = modal.dataset.forPid || '';
        var pickEl = q('#charMemberId');
        if (pickEl) { pid = pickEl.value; if (!pid) { showNotification(_tt('camp.selectMember', 'Alege un membru.'), 'error'); return; } }
        if (charId) payload.id = charId;
        if (pid) payload.profile_id = pid;   // self => rang≥1 ; altcineva => rang≥2 (RPC verifică)

        var res = await TC.upsertChar(campId, payload);
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }
        modal.remove();
        try { await TC.fetch(); await _loadCharsFull(campId); } catch (e) { logError('camp.saveCharRefresh', e); }
        _paintDetail();
        showNotification(_tt('camp.charSaved', 'Personaj salvat.'), 'success');
    };

    TC.retireCharacter = async function (charId, name) {
        if (!await confirmModal(_tt('camp.confirmRetireChar', 'Retragi personajul „{name}"?').replace('{name}', name || ''), { danger: true })) return;
        var res = await TC.retireChar(charId);
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }
        try { await TC.fetch(); if (_openCampId) await _loadCharsFull(_openCampId); } catch (e) { logError('camp.retireRefresh', e); }
        _paintDetail();
        showNotification(_tt('camp.charRetired', 'Personaj retras.'), 'info');
    };

    /* ---- Editor World State (Mod+): note, contoare, deblocări, realizări ---- */
    function _ctrRowHtml(k, v) {
        return '<div class="camp-ws-crow">' +
            '<input type="text" class="form-control ws-ck" placeholder="' + _esc(_tt('camp.ws.counterKey', 'Nume')) + '" value="' + _esc(k || '') + '">' +
            '<input type="text" class="form-control ws-cv" placeholder="' + _esc(_tt('camp.ws.counterVal', 'Valoare')) + '" value="' + _esc(v == null ? '' : String(v)) + '">' +
            '<button type="button" class="btn btn-sm btn-danger" style="width:auto; flex:none;" onclick="this.parentElement.remove()"><i class="fas fa-times"></i></button>' +
        '</div>';
    }
    TC.wsAddCounterRow = function () {
        var box = document.getElementById('wsCounters'); if (!box) return;
        box.insertAdjacentHTML('beforeend', _ctrRowHtml('', ''));
    };
    TC.openWorldState = function (campId) {
        if (!requireFeature('campaigns')) return;
        if (!_canManage()) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        document.querySelectorAll('.modal[data-ws-modal]').forEach(function (m) { m.remove(); });
        var c = _campCache.find(function (x) { return String(x.id) === String(campId); });
        if (!c) return;
        var w = _wsData(c);
        var ckeys = Object.keys(w.counters);
        var modal = document.createElement('div');
        modal.className = 'modal active';
        modal.dataset.wsModal = '1';
        modal.dataset.campId = campId;
        modal.innerHTML = '<div class="modal-content"><div class="modal-header">' +
            '<h2><i class="fas fa-earth-europe"></i> ' + _esc(_tt('camp.ws.edit', 'Editează World State')) + '</h2>' +
            '<button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button></div>' +
            '<div class="form-group"><span class="form-section-label">' + _esc(_tt('camp.ws.counters', 'Contoare')) + '</span>' +
                '<div id="wsCounters">' + (ckeys.length ? ckeys.map(function (k) { return _ctrRowHtml(k, w.counters[k]); }).join('') : _ctrRowHtml('', '')) + '</div>' +
                '<button type="button" class="btn btn-sm btn-secondary" style="width:auto; margin-top:6px;" onclick="TO_CAMP.wsAddCounterRow()"><i class="fas fa-plus"></i> ' + _esc(_tt('camp.ws.addCounter', '+ Contor')) + '</button>' +
                '<small style="display:block; color:var(--text-secondary); margin-top:6px;">' + _esc(_tt('camp.ws.counterHint', 'Contoarele se pot adăuga sau actualiza.')) + '</small></div>' +
            '<div class="form-group"><label for="wsUnlocks">' + _esc(_tt('camp.ws.unlocks', 'Deblocări')) + '</label>' +
                '<textarea id="wsUnlocks" class="form-control" rows="3" placeholder="' + _esc(_tt('camp.ws.linePh', 'câte unul pe linie')) + '">' + _esc(w.unlocks.join('\n')) + '</textarea></div>' +
            '<div class="form-group"><label for="wsAch">' + _esc(_tt('camp.ws.achievements', 'Realizări')) + '</label>' +
                '<textarea id="wsAch" class="form-control" rows="3" placeholder="' + _esc(_tt('camp.ws.linePh', 'câte unul pe linie')) + '">' + _esc(w.achievements.join('\n')) + '</textarea></div>' +
            '<div class="form-group"><label for="wsNotes">' + _esc(_tt('camp.ws.notes', 'Note')) + '</label>' +
                '<textarea id="wsNotes" class="form-control" rows="3">' + _esc(w.notes) + '</textarea></div>' +
            '<button class="btn btn-primary" onclick="TO_CAMP.saveWorldState()"><i class="fas fa-save"></i> ' + _esc(_tt('common.save', 'Salvează')) + '</button>' +
        '</div>';
        document.body.appendChild(modal);
    };
    TC.saveWorldState = async function () {
        var modal = document.querySelector('.modal.active[data-ws-modal]');
        if (!modal) return;
        var campId = modal.dataset.campId;
        var counters = {};
        modal.querySelectorAll('#wsCounters .camp-ws-crow').forEach(function (row) {
            var k = (row.querySelector('.ws-ck').value || '').trim();
            if (!k) return;
            var raw = (row.querySelector('.ws-cv').value || '').trim();
            var num = Number(raw);
            counters[k] = (raw !== '' && isFinite(num)) ? num : raw;
        });
        function lines(id) {
            return (document.getElementById(id).value || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
        }
        var patch = {
            counters: counters,
            unlocks: lines('wsUnlocks'),
            achievements: lines('wsAch'),
            notes: (document.getElementById('wsNotes').value || '').trim()
        };
        var res = await TC.setWorldState(campId, patch);
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }
        modal.remove();
        try { await TC.fetch(); } catch (e) { logError('camp.wsRefresh', e); }
        _paintDetail();
        showNotification(_tt('camp.ws.saved', 'World State salvat.'), 'success');
    };

    /* =====================================================================
       FAZA 3c — REALTIME
       Canal dedicat pe `campaigns` + `campaign_characters` (RLS livrează doar
       rândurile vizibile membrului). Sesiunile legate noi (tabelul `matches`)
       sunt prinse prin cârligul din scheduleRealtimeRefresh -> TO_CAMP.rtRefresh.
       ===================================================================== */
    function _sbReadyRT() { return (typeof sb !== 'undefined' && sb && typeof sb.channel === 'function'); }

    /* Refresh debounced: reîncarcă datele (badge inclus via TC.fetch) și, dacă
       suntem pe tabul de campanii, re-randează lista sau pagina de detaliu. */
    TC.rtRefresh = function () {
        if (_rtTimer) clearTimeout(_rtTimer);
        _rtTimer = setTimeout(function () {
            _rtTimer = null;
            if (_demo() || !state.currentUser || !currentClubId) return;
            TC.fetch().then(function () {
                if (typeof currentTab === 'undefined' || currentTab !== 'campaigns') return; // badge deja actualizat în fetch
                if (_openCampId) {
                    if (!_campCache.some(function (x) { return String(x.id) === String(_openCampId); })) { _openCampId = null; _paint(); return; }
                    return _loadCharsFull(_openCampId).then(function () { return _loadProgress(_openCampId); }).then(_paintDetail);
                }
                _paint();
            }).catch(function (e) { logError('camp.rtRefresh', e); });
        }, 350);
    };

    function subscribeRealtimeCampaigns() {
        if (!_sbReadyRT()) return;
        try {
            if (_campChannel) { try { sb.removeChannel(_campChannel); } catch (e) {} _campChannel = null; }
            _campChannel = sb.channel('public:campaigns')
                .on('postgres_changes', { event: '*', schema: 'public', table: 'campaigns' }, TC.rtRefresh)
                .on('postgres_changes', { event: '*', schema: 'public', table: 'campaign_characters' }, TC.rtRefresh)
                .subscribe();
            _campChannelUser = _curUid();
        } catch (e) { logError('subscribeRealtimeCampaigns', e); }
    }
    TC._rtCleanup = function () {
        if (_rtTimer) { clearTimeout(_rtTimer); _rtTimer = null; }
        if (_campChannel) { try { sb.removeChannel(_campChannel); } catch (e) {} _campChannel = null; }
        _campChannelUser = null;
    };
    window.subscribeRealtimeCampaigns = subscribeRealtimeCampaigns;

    /* ---------------------------------------------------- editor creare/editare */
    function openCampaignEditor(id) {
        if (!requireFeature('campaigns')) return;
        if (!_canManage()) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        document.querySelectorAll('.modal[data-campaign-id]').forEach(function (m) { m.remove(); });
        var c = id ? _campCache.find(function (x) { return String(x.id) === String(id); }) : null;
        var games = Object.keys(state.catalog || {}).sort();
        var modal = document.createElement('div');
        modal.className = 'modal active';
        modal.dataset.campaignId = id || '';
        modal.innerHTML = '<div class="modal-content"><div class="modal-header">' +
            '<h2><i class="fas fa-scroll"></i> ' + _esc(c ? _tt('camp.editTitle', 'Editează campania') : _tt('camp.newTitle', 'Campanie nouă')) + '</h2>' +
            '<button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button></div>' +
            '<div class="form-group"><label for="campName">' + _esc(_tt('camp.nameLabel', 'Nume campanie')) + '</label>' +
                '<input type="text" id="campName" class="form-control" value="' + _esc(c ? c.name : '') + '" placeholder="' + _esc(_tt('camp.namePh', '')) + '"></div>' +
            '<div class="form-group"><label for="campGameSearch">' + _esc(_tt('camp.gameLabel', 'Joc (opțional)')) + '</label>' +
                '<input type="hidden" id="campGameHidden" value="' + _esc(c ? (c.game_title || '') : '') + '">' +
                '<div id="campGamePicker">' +
                    '<div style="display:flex; gap:8px;">' +
                        '<input type="text" id="campGameSearch" class="form-control" autocomplete="off" placeholder="' + _esc(_tt('session.searchGame', 'Caută joc…')) + '" oninput="TO_CAMP.gameSearchLive()" onfocus="TO_CAMP.gameSearchLive()" style="flex:1 1 auto; min-width:0;">' +
                        '<button type="button" id="campAddGameBtn" class="tab-head-btn accent" style="flex:none; align-self:stretch; height:auto; width:46px;" onclick="openAddGameModal()" title="' + _esc(_tt('catalog.addGame', 'Adaugă joc')) + '"><i class="fas fa-plus"></i></button>' +
                    '</div>' +
                    '<div id="campGameResults" class="sess-game-results"></div>' +
                '</div>' +
                '<div id="campGameSelected" class="sess-game-selected" style="display:none;"></div></div>' +
            '<div class="form-group"><label for="campStatus">' + _esc(_tt('camp.statusLabel', 'Stare')) + '</label>' +
                '<select id="campStatus" class="form-control">' +
                    '<option value="active"' + (!c || c.status === 'active' ? ' selected' : '') + '>' + _esc(_tt('camp.inProgress', 'În desfășurare')) + '</option>' +
                    '<option value="completed"' + (c && c.status === 'completed' ? ' selected' : '') + '>' + _esc(_tt('camp.statusCompleted', 'Finalizată')) + '</option>' +
                    '<option value="abandoned"' + (c && c.status === 'abandoned' ? ' selected' : '') + '>' + _esc(_tt('camp.statusAbandoned', 'Abandonată')) + '</option>' +
                '</select></div>' +
            '<button class="btn btn-primary" onclick="saveCampaign()"><i class="fas fa-save"></i> ' + _esc(_tt('common.save', 'Salvează')) + '</button>' +
            '</div>';
        document.body.appendChild(modal);
        /* La editare: pre-selectează jocul existent în picker (dacă e în catalog). */
        if (c && c.game_title && (state.catalog || {})[c.game_title]) { try { TC.pickGame(c.game_title); } catch (e) {} }
    }

    /* ---- Picker de joc (editor campanie): identic cu cel din formularul de
       sesiune (aceleași clase sess-game-*, imagini din catalog), dar cu id-uri
       proprii ca să nu interfereze. ---- */
    TC.gameSearchLive = function () {
        var box = document.getElementById('campGameResults');
        var inp = document.getElementById('campGameSearch');
        if (!box || !inp) return;
        var addBtn = document.getElementById('campAddGameBtn');
        if (addBtn) addBtn.style.display = '';
        var q = inp.value.trim().toLowerCase();
        var parts = q ? q.split(/\s+/) : [];
        var list = Object.keys(state.catalog || {}).map(function (name) { return { name: name, g: state.catalog[name] }; });
        if (parts.length) list = list.filter(function (o) {
            var g = o.g || {};
            var hay = (o.name + ' ' + ((g.categories || []).join(' ')) + ' ' + (g.designer || '') + ' ' + (g.publisher || '') + ' ' + (g.edition || '')).toLowerCase();
            return parts.every(function (p) { return hay.indexOf(p) !== -1; });
        });
        list.sort(function (a, b) { return a.name.localeCompare(b.name); });
        list = list.slice(0, 40);
        if (!list.length) { box.innerHTML = '<div class="sess-game-empty">' + _esc(_tt('session.noGames', 'Niciun joc.')) + '</div>'; box.classList.add('show'); return; }
        box.innerHTML = list.map(function (o) {
            var g = o.g || {};
            /* ⚡ PERF §54.1: încărcare LENEȘĂ, identic cu selectoarele de joc de la sesiune
               și turnee. Până la 40 de imagini de catalog într-o casetă de 3-4 rânduri.
               `loading="lazy"` nu se aplică — e fundal CSS, nu `<img>`.
               ⚠ Garda `typeof`: helperul stă în `app-modules-1.js`, alt fișier.
               EN: same lazy pattern as the session and tournament game pickers; the helper
                   lives in `app-modules-1.js`, hence the guard with a fallback. */
            var styleImg = (typeof toLazyBgAttr === 'function')
                ? toLazyBgAttr(g.imageUrl, 'thumb')
                : (g.imageUrl ? ' style="background-image:url(\'' + gameImgCss(g.imageUrl, 'thumb') + '\');"' : '');
            return '<div class="sess-game-card' + (g.imageUrl ? '' : ' noimg') + '"' + styleImg + ' onclick="TO_CAMP.pickGame(\'' + window.attrJs(o.name) + '\')">' +
                '<div class="sess-game-card-ov"><span class="sess-game-card-title">' + window.escHtml(o.name) + '</span></div></div>';
        }).join('');
        box.classList.add('show');
        /* ⚠ DUPĂ `.show`: pe o casetă ascunsă nimic nu „intersectează".
           EN: must run after the box becomes visible. */
        try { if (typeof toObserveLazyBg === 'function') toObserveLazyBg(box); } catch (e) { logError('camp.gameSearch', e); }
    };
    TC.pickGame = function (name) {
        var hidden = document.getElementById('campGameHidden'); if (hidden) hidden.value = name;
        var g = (state.catalog || {})[name] || {};
        var sel = document.getElementById('campGameSelected');
        var picker = document.getElementById('campGamePicker');
        var box = document.getElementById('campGameResults');
        if (box) { box.innerHTML = ''; box.classList.remove('show'); }
        if (sel) {
            var styleImg = g.imageUrl ? ' style="background-image:url(\'' + gameImgCss(g.imageUrl, 'wide') + '\');"' : '';
            sel.innerHTML = '<div class="sess-game-selected-card' + (g.imageUrl ? '' : ' noimg') + '"' + styleImg + '>' +
                '<span class="sess-game-selected-title">' + window.escHtml(name) + '</span>' +
                '<button type="button" class="sess-game-clear" onclick="TO_CAMP.clearGame()" aria-label="' + _esc(_tt('common.cancel', 'Anulează')) + '"><i class="fas fa-times"></i></button></div>';
            sel.style.display = 'block';
        }
        if (picker) picker.style.display = 'none';
    };
    TC.clearGame = function () {
        var hidden = document.getElementById('campGameHidden'); if (hidden) hidden.value = '';
        var sel = document.getElementById('campGameSelected');
        var picker = document.getElementById('campGamePicker');
        var search = document.getElementById('campGameSearch');
        var box = document.getElementById('campGameResults');
        if (sel) { sel.innerHTML = ''; sel.style.display = 'none'; }
        if (picker) picker.style.display = '';
        if (search) search.value = '';
        if (box) { box.innerHTML = ''; box.classList.remove('show'); }
    };

    /* ---- Combo de membru (editor personaj, mod Mod+): identic ca UX cu „Add
       player" din formularul de sesiune (avatar + nume + @tag, click = alege). ---- */
    TC.memberSearchLive = function () {
        var list = document.getElementById('charMemberList');
        var inp = document.getElementById('charMemberSearch');
        if (!list || !inp) return;
        var q = (inp.value || '').trim().toLowerCase().replace(/^@/, '');
        var all = (typeof getSortedPlayers === 'function') ? getSortedPlayers() : [];
        var matches = q ? all.filter(function (p) { return ((p.name || '').toLowerCase().indexOf(q) !== -1) || ((p.userTag || '').toLowerCase().indexOf(q) !== -1); }) : all;
        list.style.display = 'block';
        if (!matches.length) { list.innerHTML = '<div style="padding:10px; color:var(--text-secondary); font-size:.85em;">' + _esc(_tt('session.noPlayerMatch', 'Niciun rezultat.')) + '</div>'; return; }
        list.innerHTML = matches.slice(0, 50).map(function (p) {
            var safe = window.attrJs(String(p.dbId || ''));
            var tag = p.userTag ? ' <span style="color:var(--accent-primary); font-size:.8em;">@' + _cesc(p.userTag) + '</span>' : '';
            var av = (typeof avatarHtml === 'function') ? avatarHtml(p.avatar, 26) : '';
            return '<div onclick="TO_CAMP.pickMember(\'' + safe + '\')" style="display:flex; align-items:center; gap:9px; padding:9px 12px; cursor:pointer; border-bottom:1px solid var(--border,#2a2a3a);">' +
                '<span class="sess-combo-av">' + av + '</span>' +
                '<span style="flex:1 1 auto; min-width:0;">' + _cesc(p.name) + tag + '</span>' +
                '<i class="fas fa-plus" style="opacity:.6;"></i></div>';
        }).join('');
    };
    TC.pickMember = function (id) {
        if (!id) return;
        var hid = document.getElementById('charMemberId'); if (hid) hid.value = id;
        var all = (typeof getSortedPlayers === 'function') ? getSortedPlayers() : [];
        var p = all.find(function (x) { return String(x.dbId) === String(id); }) || {};
        var sel = document.getElementById('charMemberSelected');
        var picker = document.getElementById('charMemberPicker');
        var list = document.getElementById('charMemberList');
        if (list) { list.innerHTML = ''; list.style.display = 'none'; }
        if (sel) {
            var av = (typeof avatarHtml === 'function') ? avatarHtml(p.avatar, 26) : '';
            sel.innerHTML = '<div style="display:flex; align-items:center; gap:9px; padding:9px 12px; background:var(--bg-primary,rgba(255,255,255,.05)); border:1px solid var(--border,#2a2a3a); border-radius:8px;">' +
                '<span class="sess-combo-av">' + av + '</span>' +
                '<span style="flex:1 1 auto; min-width:0;">' + _cesc(p.name || id) + '</span>' +
                '<button type="button" class="btn btn-sm btn-secondary" style="width:auto; flex:none;" onclick="TO_CAMP.clearMember()"><i class="fas fa-times"></i></button></div>';
            sel.style.display = 'block';
        }
        if (picker) picker.style.display = 'none';
    };
    TC.clearMember = function () {
        var hid = document.getElementById('charMemberId'); if (hid) hid.value = '';
        var sel = document.getElementById('charMemberSelected');
        var picker = document.getElementById('charMemberPicker');
        var search = document.getElementById('charMemberSearch');
        var list = document.getElementById('charMemberList');
        if (sel) { sel.innerHTML = ''; sel.style.display = 'none'; }
        if (picker) picker.style.display = '';
        if (search) search.value = '';
        if (list) { list.innerHTML = ''; list.style.display = 'none'; }
    };

    /* Rezolvă titlul de joc -> game_id (bigint) din catalog, dacă există. */
    function _gameIdForTitle(title) {
        if (!title) return null;
        var g = (state.catalog || {})[title];
        var raw = g && (g.id != null ? g.id : g.dbId);
        if (raw == null) return null;
        var n = parseInt(raw, 10);
        return isNaN(n) ? null : n;
    }

    async function saveCampaign() {
        var modal = document.querySelector('.modal.active[data-campaign-id]');
        if (!modal) return;
        var id = modal.dataset.campaignId;
        var name = (document.getElementById('campName').value || '').trim();
        if (!name) { showNotification(_tt('m3.nameCampaign', 'Dă un nume campaniei!'), 'error'); return; }
        var gameTitle = (document.getElementById('campGameHidden').value || '').trim();
        var status = document.getElementById('campStatus').value;
        var gid = _gameIdForTitle(gameTitle);
        var payload = { name: name, game_title: gameTitle || null };
        if (gid != null) payload.game_id = String(gid);

        var res;
        if (id) {
            res = await TC.update(id, payload);
            if (res.ok) { var r2 = await TC.setStatus(id, status); if (!r2.ok) res = r2; }
        } else {
            payload.status = status;
            res = await TC.create(payload);
        }
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }  /* DB-first: nimic local pe eroare */
        var _wasNew = !id, _newId = _wasNew ? (res.data || null) : null;
        modal.remove();
        try { await TC.fetch(); } catch (e) { logError('camp.saveRefresh', e); }
        if (_openCampId) { try { await _loadCharsFull(_openCampId); } catch (e) { logError('camp.saveRefresh2', e); } _paintDetail(); } else _paint();
        showNotification(_tt('camp.saved', 'Campanie salvată.'), 'success');
        /* Notificare „campanie nouă" către ceilalți membri (ca la turnee: înscriere→membri). */
        if (_wasNew) {
            try { _campNotify(_campMemberIds(), _newId, _campNotifText('camp.notif.new', 'New campaign: {name}', name), 'fa-dragon'); }
            catch (e) { logError('camp.notifNew', e); }
        }
    }

    async function deleteCampaign(id) {
        var c = _campCache.find(function (x) { return String(x.id) === String(id); });
        if (!c) return;
        if (!_canManage()) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        if (!await confirmModal(_tt('m3.confirmDeleteCampaign', 'Ștergi campania „{name}"?').replace('{name}', c.name), { danger: true })) return;
        var res = await TC.del(id);
        if (!res.ok) { showNotification(_errMsg(res.error), 'error'); return; }
        try { await TC.fetch(); } catch (e) { logError('camp.delRefresh', e); }
        _openCampId = null; _paint();
        showNotification(_tt('m3.campaignDeleted', 'Campanie ștearsă.'), 'info');
    }

    /* ---------------------------------------------- legare sesiune ↔ campanie */
    /* Forțează scorarea de campanie (uniform + kind=campaign) dacă clubul are
       șabloanele activate. Fără atingerea altor fluxuri. Întoarce true dacă a reușit. */
    function _forceCampaignScoring() {
        try {
            var tpl = (typeof getScoringTemplates === 'function') ? getScoringTemplates() : null;
            if (!tpl || !tpl.enabled) return false;
            var modeSel = document.getElementById('sessionScoreMode');
            if (modeSel) { modeSel.value = 'uniform'; }
            if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode();
            var kindSel = document.getElementById('sessionScoreKind');
            if (kindSel) { kindSel.value = 'campaign'; if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode(); }
            if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
            return true;
        } catch (e) { logError('camp.forceScoring', e); return false; }
    }

    /* Roster de pornire = personaje active; dacă niciunul, participanții ultimei
       sesiuni legate. Întoarce array de profile_id (doar membri reali cunoscuți). */
    function _rosterFor(campId) {
        var ids = (_charByCamp[campId] || []).slice();
        if (!ids.length) {
            var ms = _matchByCamp[campId] || [];
            var last = ms[ms.length - 1];
            if (last && Array.isArray(last.players)) ids = last.players.slice();
        }
        var seen = {};
        return ids.filter(function (id) {
            if (seen[id]) return false; seen[id] = 1;
            return (typeof memberById === 'function') ? !!memberById(id) : !!(state.membersById && state.membersById[id]);
        });
    }

    /* Pre-completează jocul: potrivire exactă sau case-insensitive în catalog ->
       pickSessionGame; altfel pune titlul în căutare ca punct de plecare. */
    function _prefillGame(title) {
        if (!title) return;
        var cat = state.catalog || {};
        var key = cat[title] ? title : null;
        if (!key) {
            var lt = String(title).trim().toLowerCase();
            key = Object.keys(cat).find(function (k) { return k.toLowerCase() === lt; }) || null;
        }
        if (key && typeof pickSessionGame === 'function') { pickSessionGame(key); return; }
        var s = document.getElementById('sessionGameSearch');
        if (s) { s.value = title; if (typeof sessionGameSearchLive === 'function') sessionGameSearchLive(); }
    }

    TC.startSession = function (campId) {
        if (!requireFeature('campaigns')) return;
        if (typeof can === 'function' && !can('session.create')) { showNotification(_tt('rbac.noPermission', 'Nu ai permisiunea.'), 'error'); return; }
        var c = _campCache.find(function (x) { return String(x.id) === String(campId); });
        if (!c) { showNotification(_tt('camp.err.notFound', 'Campania nu există.'), 'error'); return; }
        if (c.status !== 'active') { showNotification(_tt('camp.err.notActive', 'Campania nu este activă. Redeschide-o pentru a adăuga sesiuni.'), 'error'); return; }
        /* switchTab -> renderSessionForm (reset complet). Pre-completăm DUPĂ ce formularul
           s-a randat integral (un tick), ca reset-ul să nu ne șteargă valorile. */
        if (typeof switchTab === 'function') switchTab('session');
        setTimeout(function () {
            try {
                if (typeof setSessionType === 'function') setSessionType('standard');
                window._sessCampaignId = c.id;
                try { _prefillGame(c.game_title); } catch (e) { logError('camp.ss.game', e); }
                try {
                    var roster = _rosterFor(c.id);
                    if (typeof sessionPlayers !== 'undefined' && Array.isArray(sessionPlayers)) {
                        sessionPlayers.length = 0;
                        roster.forEach(function (id) { sessionPlayers.push(id); });
                    }
                    if (typeof renderSelectedSessionPlayers === 'function') renderSelectedSessionPlayers();
                    if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
                    if (typeof renderPlayerCombo === 'function') renderPlayerCombo();
                } catch (e) { logError('camp.ss.roster', e); }
                var scored = _forceCampaignScoring();
                _renderAttachControl(c.id);
                showNotification(_tt('camp.sessionStarted', 'Sesiune de campanie pornită: {name}').replace('{name}', c.name) +
                    (scored ? '' : ' — ' + _tt('camp.needUniformNote', 'activează scorarea uniformizată în Admin pentru Puncte de Club.')), 'info');
            } catch (e) { logError('camp.startSession', e); }
        }, 0);
    };

    /* Selector discret „Atașează la campanie" în foaia de sesiune. Se randează în
       #sessCampaignAttachWrap; apare DOAR la tip standard și dacă există campanii active. */
    var _attachFetchP = null; // promisiune PARTAJATĂ pt. fetch-ul lazy (anti-cursă)

    /* Randare PURĂ din cache (fără fetch) — apelată și după ce fetch-ul se termină. */
    function _paintAttach(wrap, selectedId) {
        if (!wrap) return;
        var active = _campCache.filter(function (c) { return c.status === 'active'; });
        if (!active.length) { wrap.innerHTML = ''; return; }
        var cur = selectedId != null ? selectedId : (window._sessCampaignId || '');
        var opts = '<option value="">' + _esc(_tt('camp.attachNone', '— fără campanie —')) + '</option>' +
            active.map(function (c) { return '<option value="' + _esc(c.id) + '"' + (String(c.id) === String(cur) ? ' selected' : '') + '>' + _esc(c.name) + '</option>'; }).join('');
        var scn = (document.getElementById('sessionScenarioName') || {}).value || '';
        wrap.innerHTML = '<div class="form-group camp-attach">' +
            '<label for="sessCampaignAttach" style="margin-bottom:4px;"><i class="fas fa-scroll"></i> ' + _esc(_tt('camp.attachLabel', 'Atașează la campanie')) + '</label>' +
            '<select id="sessCampaignAttach" class="form-control" onchange="TO_CAMP._onAttach(this.value)">' + opts + '</select>' +
            (cur ? '<div style="margin-top:8px;"><label for="sessionScenarioName" style="margin-bottom:4px; font-size:.9em;"><i class="fas fa-flag"></i> ' + _esc(_tt('camp.scenarioLabel', 'Scenariu (opțional)')) + '</label>' +
                '<input type="text" id="sessionScenarioName" class="form-control" value="' + _esc(scn) + '" placeholder="' + _esc(_tt('camp.scenarioPh', 'Ex: Scenariul 3 — Cripta')) + '"></div>' : '') +
            '</div>';
    }

    function _renderAttachControl(selectedId) {
        var wrap = document.getElementById('sessCampaignAttachWrap');
        if (!wrap) return;
        var type = (typeof currentSessionType !== 'undefined' && currentSessionType) ? currentSessionType : 'standard';
        if (_demo() || type !== 'standard' || !planAllows('campaigns')) { wrap.innerHTML = ''; return; }
        /* Cache-ul aparține altui club (sau nu e încă adus)? Adu-l O SINGURĂ DATĂ
           (promisiune partajată => fără cursă între apeluri concurente) și randează
           din cache la final. NU golim wrap-ul între timp (fără pâlpâire). */
        if (!_freshForClub()) {
            if (typeof sb !== 'undefined' && sb && currentClubId) {
                if (!_attachFetchP) {
                    _attachFetchP = TC.fetch()
                        .then(function () { _attachFetchP = null; })
                        .catch(function () { _attachFetchP = null; });
                }
                var want = (selectedId != null ? selectedId : (window._sessCampaignId || ''));
                _attachFetchP.then(function () {
                    var w = document.getElementById('sessCampaignAttachWrap');
                    if (w) _paintAttach(w, window._sessCampaignId || want); /* paint pur: fără re-fetch => fără buclă */
                });
            } else {
                wrap.innerHTML = '';
            }
            return;
        }
        _paintAttach(wrap, selectedId);
    }
    TC._renderAttach = _renderAttachControl;

    /* Diagnostic: de ce e (sau nu) vizibil controlul „Atașează la campanie". */
    TC._attachWhy = function () {
        var wrap = document.getElementById('sessCampaignAttachWrap');
        var type = (typeof currentSessionType !== 'undefined' && currentSessionType) ? currentSessionType : 'standard';
        var active = _campCache.filter(function (c) { return c.status === 'active'; });
        return {
            wrapPresent: !!wrap,
            currentTab: (typeof currentTab !== 'undefined' ? currentTab : '?'),
            sessionType: type,
            demo: _demo(),
            planAllows: !!planAllows('campaigns'),
            freshForClub: _freshForClub(),
            campClubId: _campClubId,
            currentClubId: (typeof currentClubId !== 'undefined' ? currentClubId : null),
            cacheCount: _campCache.length,
            activeCount: active.length,
            activeNames: active.map(function (c) { return c.name; })
        };
    };

    TC._onAttach = function (val) {
        window._sessCampaignId = val || null;
        if (val) _forceCampaignScoring();
        _renderAttachControl(val || '');
    };

    /* Curăță atașarea (apelat din wrap-ul clearSessionForm/renderSessionForm).
       Re-randează controlul cu selecție goală (NU golește), altfel „Atașează la
       campanie" dispare după butonul Reset până la refresh. */
    TC._clearAttach = function () {
        window._sessCampaignId = null;
        _renderAttachControl('');
    };

    /* Cronologie (citire) — expusă pentru Faza 3. */
    TC.matchesForCampaign = function (campId) { return (_matchByCamp[campId] || []).slice(); };
    TC._cache = function () { return _campCache.slice(); };

    /* -------- Faza 5c: „Evoluția personajului" pe profilul public --------------
       Injectat async într-un container (#ppCharEvolution / #playerCharEvolution).
       Citește campaign_characters ale profilului DIN CLUBUL CURENT (RLS = membru),
       plus numele/statusul campaniilor. Se ascunde dacă nu există date. */
    TC.injectCharEvolution = async function (containerId, profileId) {
        var el = document.getElementById(containerId);
        if (!el || _demo() || typeof sb === 'undefined' || !sb || !currentClubId || !profileId) return;
        try {
            var cr = await sb.from('campaign_characters')
                .select('id,char_name,char_class,level,xp,gold,status,campaign_id')
                .eq('profile_id', profileId).eq('club_id', currentClubId);
            if (cr.error || !cr.data || !cr.data.length) return;
            var chars = cr.data;
            var ids = chars.map(function (c) { return c.campaign_id; })
                .filter(function (v, i, a) { return v && a.indexOf(v) === i; });
            var campById = {};
            if (ids.length) {
                try {
                    var kr = await sb.from('campaigns').select('id,name,status').in('id', ids);
                    (kr.data || []).forEach(function (k) { campById[k.id] = k; });
                } catch (e) { logError('camp.evoCamps', e); }
            }
            /* Activ înainte de retras; apoi nivel descrescător. */
            chars.sort(function (a, b) {
                if ((a.status === 'active') !== (b.status === 'active')) return a.status === 'active' ? -1 : 1;
                return _num(b.level, 1) - _num(a.level, 1);
            });
            var rows = chars.map(function (ch) {
                var camp = campById[ch.campaign_id] || {};
                var done = camp.status === 'completed';
                var retired = ch.status === 'retired';
                return '<div class="pp-evo-card' + (retired ? ' retired' : '') + '">' +
                    '<div class="pp-evo-top"><span class="pp-evo-name">' + _cesc(ch.char_name) + '</span>' +
                        (ch.char_class ? '<span class="pp-evo-class">' + _cesc(ch.char_class) + '</span>' : '') +
                        (retired ? '<span class="pp-evo-tag">' + _esc(_tt('camp.evo.retired', 'retras')) + '</span>' : '') +
                    '</div>' +
                    (camp.name ? '<div class="pp-evo-camp">📜 ' + _cesc(camp.name) +
                        (done ? ' <span class="pp-evo-done">✓ ' + _esc(_tt('camp.completedF', 'Finalizată')) + '</span>' : '') + '</div>' : '') +
                    '<div class="pp-evo-stats">' +
                        '<span title="' + _esc(_tt('camp.lvl', 'Nv.')) + '">🎚️ ' + _num(ch.level, 1) + '</span>' +
                        '<span title="XP">✨ ' + _num(ch.xp, 0) + '</span>' +
                        '<span title="' + _esc(_tt('camp.gold', 'Aur')) + '">🪙 ' + _num(ch.gold, 0) + '</span>' +
                    '</div>' +
                '</div>';
            }).join('');
            el.innerHTML = '<div class="pp-evo"><div class="pp-evo-h"><i class="fas fa-scroll"></i> ' +
                _esc(_tt('camp.evo.title', 'Evoluția personajului')) + '</div>' + rows + '</div>';
        } catch (e) { logError('camp.injectEvo', e); }
    };

    /* ------------------------------------------------------- Override Map (§5)
       Umbrește funcțiile vechi din app-modules-3.js cu ACELEAȘI nume (last-wins). */
    window.renderCampaigns = renderCampaigns;
    window.openCampaignEditor = openCampaignEditor;
    window.saveCampaign = saveCampaign;
    window.deleteCampaign = deleteCampaign;
    /* Scenariile sunt acum sesiuni reale: „+ Scenariu" -> „+ Sesiune de campanie". */
    window.addCampaignScenario = function (campId) { TC.startSession(campId); };
    window.saveCampaignScenario = function () { showNotification(_tt('camp.scenarioObsolete', 'Scenariile se adaugă acum ca sesiuni de campanie.'), 'info'); };
    window.deleteCampaignScenario = function () { showNotification(_tt('camp.deleteViaHistory', 'Șterge sesiunea din Istoric.'), 'info'); };
    window.persistCampaigns = function () { return Promise.resolve(); }; /* blob abandonat — no-op */
    window.campaignRecord = function (c) { var ms = (c && _matchByCamp[c.id]) || []; return { total: ms.length, wins: 0, losses: 0 }; };
    window.TO_CAMP = TC;

    /* ------------------------------------------- wrap-uri pe foaia de sesiune */
    if (!window._campSessWrapped) {
        window._campSessWrapped = true;
        var _origClear = window.clearSessionForm;
        window.clearSessionForm = function () {
            var r = (typeof _origClear === 'function') ? _origClear.apply(this, arguments) : undefined;
            try { TC._clearAttach(); } catch (e) { logError('camp.wrapClear', e); }
            return r;
        };
        var _origRender = window.renderSessionForm;
        window.renderSessionForm = function () {
            var r = (typeof _origRender === 'function') ? _origRender.apply(this, arguments) : undefined;
            /* Tab-ul session s-a deschis proaspăt: fără campanie atașată implicit. */
            try { window._sessCampaignId = null; _renderAttachControl(''); } catch (e) { logError('camp.wrapRender', e); }
            return r;
        };
        var _origType = window.setSessionType;
        window.setSessionType = function () {
            var r = (typeof _origType === 'function') ? _origType.apply(this, arguments) : undefined;
            try { _renderAttachControl(window._sessCampaignId || ''); } catch (e) { logError('camp.wrapType', e); }
            return r;
        };
        /* render() global folosește renderSessionRefresh (păstrează formularul) — îl
           acoperim și pe el, altfel attach-ul dispare la refresh-urile globale. */
        var _origRefresh = window.renderSessionRefresh;
        window.renderSessionRefresh = function () {
            var r = (typeof _origRefresh === 'function') ? _origRefresh.apply(this, arguments) : undefined;
            try {
                if (typeof currentTab === 'undefined' || currentTab === 'session') _renderAttachControl(window._sessCampaignId || '');
            } catch (e) { logError('camp.wrapRefresh', e); }
            return r;
        };
    }

    /* --------------------------------------------------------- self-teste (pure) */
    (function _selfTestCampaigns() {
        try {
            var pass = 0, fail = 0;
            function ok(cond, name) { if (cond) pass++; else { fail++; console.warn('[camp selftest] FAIL:', name); } }
            ok(_errKey('FORBIDDEN') === 'camp.err.forbidden', 'errKey forbidden');
            ok(_errKey('PLAN_REQUIRED') === 'camp.err.plan', 'errKey plan');
            ok(_errKey('random text') === 'camp.err.generic', 'errKey generic');
            ok(_errKey('TARGET_NOT_MEMBER') === 'camp.err.notMember', 'errKey notMember');
            var g = _groupMatches([
                { meta: { campaignId: 'a' }, date: '2025-02-01' },
                { meta: { campaignId: 'a' }, date: '2025-01-01' },
                { meta: { campaignId: 'b' }, date: '2025-03-01' },
                { meta: {}, date: '2025-04-01' }
            ]);
            ok(g.a && g.a.length === 2, 'group a count');
            ok(g.a[0].date === '2025-01-01', 'group a sorted asc');
            ok(g.b && g.b.length === 1, 'group b count');
            ok(!g.undefined, 'group ignores missing id');
            console.log('[camp selftest] ' + pass + '/' + (pass + fail) + ' PASS');
        } catch (e) { console.warn('[camp selftest] error', e); }
    })();

})();
